<div class="container-fluid">
    <div class="row pathogen">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <h5> {{ 'farm.crop.disease.pathogenInfo' | translate }}
                        <i class="material-icons f-right">save</i>
                    </h5>
                </div>
                <div class="card-body">
                    <fap-edit
                        [context]="'pathogen'"
                        [showSubmit]="false">
                    </fap-edit>
                </div>
            </div>
        </div>
    </div>
    <fap-edit-treatments></fap-edit-treatments>
    <fap-edit-attributes></fap-edit-attributes>
</div>